import { render } from "./illustration.vue?vue&type=template&id=18034262&scoped=true"
import script from "./illustration.vue?vue&type=script&lang=js"
export * from "./illustration.vue?vue&type=script&lang=js"

import "./illustration.vue?vue&type=style&index=0&id=18034262&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18034262"]])

export default __exports__